import { UpdateSolicitationsFixedCostModel } from "./update-solictiationsFixedCost.model";

export class UpdateFixedCostModel {
  fixedCostId!: number;
  solicitations: UpdateSolicitationsFixedCostModel[] = [];
}
